import store from "store2";
const REDIRECT_PATH_KEY = "redirectPath";

export const redirectUtils = {
  // 保存重定向路径
  saveRedirectPath(path: string) {
    try {
      store.set(REDIRECT_PATH_KEY, path);
      return true;
    } catch (error) {
      return false;
    }
  },

  // 获取重定向路径
  getRedirectPath(): string | null {
    try {
      const path = store.get(REDIRECT_PATH_KEY);
      return path;
    } catch (error) {
      return null;
    }
  },

  // 清除重定向路径
  clearRedirectPath() {
    try {
      store.remove(REDIRECT_PATH_KEY);
      return true;
    } catch (error) {
      return false;
    }
  },

  // 检查是否有保存的路径
  hasRedirectPath(): boolean {
    try {
      const path = store.get(REDIRECT_PATH_KEY);
      return !!path && path !== "#/login";
    } catch (error) {
      return false;
    }
  }
};
